/**
 * Classe de gestion d'utilisateur
 */

export default class User {

    /**
     * Retourne le slug en fonction du type en camelCase en paramètre
     * @param string camelCaseType
     * @return string|null
     */
    static getSlugTypeByCamel(camelCaseType) {
        const camelTypes = {
            internalAgent: 'internal-agents',
            externalAgent: 'external-agents',
            teamManager: 'team-managers',
            productManager: 'product-managers',
            agencyManager: 'agency-managers',
            customer: 'customers'
        };
        return (camelTypes[camelCaseType] || null);
    };

    /**
     * Retourne le type d'utilisateur en version camelCase du type au format slug en paramètre
     * @param slugType
     * @returns string|null
     */
    static getCamelTypeBySlug(slugType) {
        const slugs = {
            'internal-agents': 'internalAgent',
            'external-agents': 'externalAgent',
            'team-managers': 'teamManager',
            'product-managers': 'productManager',
            'agency-managers': 'agencyManager',
            'customers': 'customer'
        };
        return (slugs[slugType] || null);
    };

    /**
     * Retourne la permission pour la consulter de la liste des utilisateurs en fonction du type
     * @param string userTypeCameCase Type d'utilisateur au format camelCase
     * @return string|null
     */
    static getConsultPermissionByType(userTypeCameCase) {
        const permissionByType = {
            internalAgent: 'consult internal agents',
            externalAgent: 'consult external agents',
            teamManager: 'consult managers',
            productManager: 'consult product managers',
            agencyManager: 'consult agency managers',
            customer: 'consult customers'
        }
        return (permissionByType[userTypeCameCase] || null);
    };

    /**
     * Retourne la permission pour la création d'un utilisateur en fonction du type
     * @param string userTypeCameCase Type d'utilisateur au format camelCase
     * @return string|null
     */
    static getCreatePermissionByType(userTypeCameCase) {
        const permissionByType = {
            internalAgent: 'create internal agent',
            externalAgent: 'create external agent',
            teamManager: 'create manager',
            productManager: 'create product manager',
            agencyManager: 'create agency manager',
            customer: 'create customer'
        }
        return (permissionByType[userTypeCameCase] || null);
    };

    /**
     * Retourne la permission pour lédition d'un utilisateur en fonction du type
     * @param string userTypeCameCase Type d'utilisateur au format camelCase
     * @return string|null
     */
    static getEditPermissionByType(userTypeCameCase) {
        const permissionByType = {
            internalAgent: 'edit internal agent',
            externalAgent: 'edit external agent',
            teamManager: 'edit manager',
            productManager: 'edit product manager',
            agencyManager: 'edit agency manager',
            customer: 'edit customer'
        }
        return (permissionByType[userTypeCameCase] || null);
    };

};
